/**
 * Translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    NO_ROWS_MENTIONS: 'Sem menções'
  },
  SENTENCE: {
    INSTAGRAM_LINK: 'Mencionaste a Prozis no instagram no dia {publishedAt}',
    NO_ROWS_MENTIONS: 'Ainda não mencionaste a prozis no teu Instagram'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
